import {
	Component,
	ViewEncapsulation,
	HostListener,
	ChangeDetectorRef
} from '@angular/core';

import { EventsService } from '@coreui/services/event.service'


@Component({
	selector: 		'heading3',
	encapsulation: ViewEncapsulation.None,
	template:	`
		<div class="h3" onsurface heading-display-font-family>
			<ng-content></ng-content>
		</div>
	`,

})


export class TypographyHeading3Component {

	private changeDetectorRef: ChangeDetectorRef
    private eventsService: EventsService


	constructor(private ref: ChangeDetectorRef, private _eventsService: EventsService) {
		this.changeDetectorRef = ref
		this.eventsService = _eventsService
	}

	ngOnInit() {
	}

	ngAfterViewInit() {
	}

	ngOnDestroy() {
	}


}
